import { render, staticRenderFns } from "./sushi.vue?vue&type=template&id=7f596e74"
import script from "./sushi.vue?vue&type=script&lang=js"
export * from "./sushi.vue?vue&type=script&lang=js"
import style0 from "./sushi.vue?vue&type=style&index=0&id=7f596e74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports